import * as OfflinePluginRuntime from 'offline-plugin/runtime';
import * as Sentry from '@sentry/browser';
import Log from '@app/lib/log';
import domReady from '@wordpress/dom-ready';
import {bootstrapData} from '@app/lib/utilities';
import '@app/lib/buttons';

const pageTitle = bootstrapData('page-title');
const ts = bootstrapData('ts');

if (Log.sentry.includes(CONFIG.env)) {
  Sentry.init({
    dsn: CONFIG.sentryPublicDSN,
    env: CONFIG.env,
    release: ts,
  });
}

OfflinePluginRuntime.install();
mixpanel.set_config({debug: false});
domReady(function() {
  if (pageTitle) {
    mixpanel.track('Page Viewed', {'Page Name': pageTitle});
  }
});
